import { eventLasagnaApi as api } from './eventLasagnaApi';
export const addTagTypes = ['matching'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      matchingEventLasagnaList: build.query<
        MatchingEventLasagnaListApiResponse,
        MatchingEventLasagnaListApiArg
      >({
        query: queryArg => ({
          url: `/matching/event_lasagna/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['matching']
      }),
      matchingEventLasagnaCreate: build.mutation<
        MatchingEventLasagnaCreateApiResponse,
        MatchingEventLasagnaCreateApiArg
      >({
        query: queryArg => ({
          url: `/matching/event_lasagna/`,
          method: 'POST',
          body: queryArg.eventLasagna
        }),
        invalidatesTags: ['matching']
      }),
      matchingEventLasagnaPartialUpdate: build.mutation<
        MatchingEventLasagnaPartialUpdateApiResponse,
        MatchingEventLasagnaPartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/matching/event_lasagna/${queryArg.uuid}/`,
          method: 'PATCH',
          body: queryArg.eventLasagna
        }),
        invalidatesTags: ['matching']
      }),
      matchingEventLasagnaDelete: build.mutation<
        MatchingEventLasagnaDeleteApiResponse,
        MatchingEventLasagnaDeleteApiArg
      >({
        query: queryArg => ({
          url: `/matching/event_lasagna/${queryArg.uuid}/`,
          method: 'DELETE'
        }),
        invalidatesTags: ['matching']
      }),
      matchingTotalMyMatchesTotalMyMatches: build.query<
        MatchingTotalMyMatchesTotalMyMatchesApiResponse,
        MatchingTotalMyMatchesTotalMyMatchesApiArg
      >({
        query: queryArg => ({
          url: `/matching/total_my_matches/total_my_matches/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['matching']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type MatchingEventLasagnaListApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: EventLasagnaRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingEventLasagnaListApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type MatchingEventLasagnaCreateApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: EventLasagnaRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingEventLasagnaCreateApiArg = {
  eventLasagna: EventLasagna;
};
export type MatchingEventLasagnaPartialUpdateApiResponse =
  /** status 200 Custom Response */ {
    results: EventLasagnaRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingEventLasagnaPartialUpdateApiArg = {
  uuid: string;
  eventLasagna: EventLasagna;
};
export type MatchingEventLasagnaDeleteApiResponse =
  /** status 200 Custom Response */ {
    results: EventLasagnaRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingEventLasagnaDeleteApiArg = {
  uuid: string;
};
export type MatchingTotalMyMatchesTotalMyMatchesApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: TotalMatchesResponse;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingTotalMyMatchesTotalMyMatchesApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type EventLasagna = {
  user: string;
  date_of_delivery: string;
  recipient_name: string;
  city_or_state: string;
  number_of_lasagnas: number;
  people_impact: number;
};
export type EventLasagnaRead = {
  uuid?: string;
  user: string;
  date_of_delivery: string;
  recipient_name: string;
  city_or_state: string;
  number_of_lasagnas: number;
  people_impact: number;
  created_at?: string;
  updated_at?: string;
};
export type YearMatchData = {
  year: number;
  matches: {
    [key: string]: number;
  };
};
export type TotalMatchesResponse = {
  total_delivered: number;
  total_neighborhood: number;
};
export const {
  useMatchingEventLasagnaListQuery,
  useMatchingEventLasagnaCreateMutation,
  useMatchingEventLasagnaPartialUpdateMutation,
  useMatchingEventLasagnaDeleteMutation,
  useMatchingTotalMyMatchesTotalMyMatchesQuery
} = injectedRtkApi;
